import { createFileRoute } from '@tanstack/react-router';

import { PageContainer } from '../components/layout/page-container';
import { PageHeader } from '../components/ui/page-header';
import { GatePrompt, useActionGate } from '../features/auth/action-gate';
import { ArticleEditor } from '../features/articles/editor/article-editor';

/**
 * PD 수첩 article submission (투고, V4 §C). CSR (write screen). Gated by login +
 * onboarding via the action gate. The magazine editor (ArticleEditor) creates the
 * article on submit (isActive=false → 관리자 검수 후 노출) and opens the
 * author-visible detail.
 */
export const Route = createFileRoute('/articles/create')({
  // 로그인 화면 — 세션이 브라우저에만 있다. 서버는 레이아웃만 그린다(docs/SSR.md).
  ssr: false,
  component: NewArticlePage,
});

function NewArticlePage() {
  const gate = useActionGate();

  if (gate !== 'ready') {
    return (
      <PageContainer>
        <PageHeader
          title="글쓰기"
          description="우리 일터에서 짚어야 할 이야기를 취재하듯 적어 주세요. 관리자 검수 후 아티클에 등록됩니다."
        />
        <GatePrompt status={gate} message="기사를 투고하려면 로그인이 필요해요." />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <ArticleEditor />
    </PageContainer>
  );
}
